import React, { useMemo, useState } from 'react';
import {Popover, Card, Typography, Space} from 'antd';
import {MoonOutlined, SunOutlined} from "@ant-design/icons";
import {useEnsureTickersLoaded} from "../../hooks/useEnsureTickersLoaded";
import {useSelector} from "react-redux";
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import {stringMixin} from "../../utils/strings";


const getUniqueSymbols = (calendarEvents)=>{
    let symbols = [];
    let isDefault=  false;
    calendarEvents?.forEach?.(x=>{
        if (!symbols.includes(x.symbol)) symbols.push(x.symbol);
        if (Array.isArray(x.data)){
            x.data.forEach(y=>{
                if (!symbols.includes(y.symbol)) symbols.push(y.symbol);
            })
        }
    });
    if (symbols.length===0) {
        isDefault = true;
        symbols = ['spy'];
    } // Default to SPY if no symbols are found
    return [symbols, isDefault];
}


const getUniqueEvents = (calendar)=>{
    const events = [];
    const added = [];


    calendar.forEach(x=>{
        if (x.type==='etf'){
            x.data.forEach(y=>{
                if (!added.includes(y.symbol)) {
                    events.push(y);
                    added.push(y.symbol);
                }
            })
        }
    });
    return events;
}

const mapEventsToCalendar = (events, tickers) => {
    if (!events || !tickers) return [];
    return events.map(event => {
        const tickerObject = tickers.find(x => x.symbol === event.symbol);
        return {
            start: moment(event.data[event.event_type==='upcomingdividend'?'payment_date':'report_date']).toDate(),
            end: moment(event.data[event.event_type==='upcomingdividend'?'payment_date':'report_date']).toDate(),
            title: `$${event.symbol.toUpperCase()} ${stringMixin.fmt(tickerObject?.name ?? '')}: ${event.event_type.replace('upcoming', '')}`,
            description: event.event_type === 'upcomingdividend' ?
                `Expected Dividend: $${event.data.dollar_value} on ${event.data.payment_date}. Must be owned by ${event.data.ex_date}` :
                `Earnings Estimate: $${event.data.estimate_dollar} on ${event.data.report_date}`,
            type: event.event_type,
            symbol: event.symbol,
            shortDesc: event.event_type === 'upcomingdividend' ?
                `Dividend $${event.data.dollar_value} -- ${event.data.ex_date}` :
                `Est of $ ${event.data.estimate_dollar} per share`,

        };
    });
};

const useTickerCalendar = () => {
    const calendar = useSelector((state)=>state.user.upcomingEvents);
    const uniqueCalendarItems = getUniqueEvents(calendar||[]);
    const [uniqueSymbols, isDefaultTicker] = getUniqueSymbols(calendar);
    const { tickers, loading } = useEnsureTickersLoaded(uniqueSymbols);
    const events = mapEventsToCalendar(uniqueCalendarItems, tickers || []);


    return {
        events,
        uniqueSymbols
    }



}


export default useTickerCalendar;